import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles/ResetPassword.styles.scss';

type ResetPasswordFormProps = {
    onClose: () => void;
    onConfirm: (email: string) => void;
};

export const ResetPasswordForm = ({ onClose, onConfirm }: ResetPasswordFormProps) => {
    const { t } = useTranslation();
    const [usernameOrMail, setUsernameOrMail] = useState('');

    const handleConfirm = () => {
        onConfirm(usernameOrMail);
    };

    return (
        <div className="reset-password-form">
            <h1>{t('password.reset_label')}</h1>
            <h2>{t('password.reset_input')}</h2>
            <span className="reset-password-form__input">
                <input
                    type="text"
                    value={usernameOrMail}
                    onChange={(e) => setUsernameOrMail(e.target.value)}
                    placeholder={t('password.reset_placeholder') || ''}
                />
            </span>
            <div
                style={{
                    marginTop: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                }}
            >
                <button
                    className="cancel-button"
                    onClick={onClose}
                >
                    {t('label.cancel')}
                </button>
                <button
                    className="confirm-button"
                    onClick={handleConfirm}
                >
                    {t('label.confirm')}
                </button>
            </div>
        </div>
    );
};
